var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTagFreeCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.43604 9.87354C8.55458 7.24762 11.2365 5.13168 14.2833 3.68228C17.3301 2.23287 20.6638 1.48711 24.0377 1.50017C27.4117 1.51323 30.7395 2.28477 33.775 3.75772C36.8104 5.23066 39.4759 7.3673 41.574 10.0095",
    stroke: "#101820",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 37.5C8.08766 40.2901 10.7962 42.556 13.9111 44.1181C17.026 45.6803 20.4618 46.4959 23.9465 46.5003C27.4312 46.5048 30.8691 45.698 33.988 44.1438C37.1069 42.5897 39.8212 40.3308 41.916 37.546",
    stroke: "#101820",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 31.5V19.5C3 18.7044 3.31607 17.9413 3.87868 17.3787C4.44129 16.8161 5.20435 16.5 6 16.5H9",
    stroke: "#101820",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 25.5H7.5",
    stroke: "#101820",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 31.5V16.5",
    stroke: "#101820",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15 16.5H17.25C18.2446 16.5 19.1984 16.8951 19.9017 17.5983C20.6049 18.3016 21 19.2554 21 20.25C21 21.2446 20.6049 22.1984 19.9017 22.9017C19.1984 23.6049 18.2446 24 17.25 24H15",
    stroke: "#101820",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21 31.5L16.5 24",
    stroke: "#101820",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33 31.5H30C29.2044 31.5 28.4413 31.1839 27.8787 30.6213C27.3161 30.0587 27 29.2956 27 28.5V19.5C27 18.7044 27.3161 17.9413 27.8787 17.3787C28.4413 16.8161 29.2044 16.5 30 16.5H33",
    stroke: "#101820",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27 25.5H33",
    stroke: "#101820",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M45 31.5H42C41.2044 31.5 40.4413 31.1839 39.8787 30.6213C39.3161 30.0587 39 29.2956 39 28.5V19.5C39 18.7044 39.3161 17.9413 39.8787 17.3787C40.4413 16.8161 41.2044 16.5 42 16.5H45",
    stroke: "#101820",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39 25.5H45",
    stroke: "#101820",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagFreeCircle);
export default __webpack_public_path__ + "static/media/tag-free-circle.83e23b264e0f8e694cf297de03f3bef8.svg";
export { ForwardRef as ReactComponent };